module.exports = __webpack_public_path__ + "static/img/200324.8d84f5f5.png";